const Condition = require( './Condition' );
const HealEvent = require( '../events/HealEvent' );
const { logError } = require('../logger')

const RecuperatingCondition = function( instigator, owner, battleState, potency ) {
	const condition = new Condition( instigator, owner, battleState, potency );
	condition.handle = 'recuperating';

	condition.ticks = 60;

	condition.applyHeal = function() {
    try {
  		if( owner.dead || !battleState || !battleState.allUnits ) {
  			this.expire();
  			return;
  		}
  		
  		if( battleState.paused ) {
  			return;
  		}

  		// apply bleed damage
  		const healEvent = new HealEvent( battleState, battleState.allUnits[this.instigatorId], this.potency );
  		healEvent.execute( battleState.allUnits[this.ownerId] );

  		if( (--this.ticks) <= 0 ) {
  			this.expire();
  		}
    } catch (err) {
      logError(err, {
        module: 'RecuperatingCondition',
        func: 'applyHeal',
        instigator,
        owner,
        battleState,
        potency
      })
    }
	}

	condition.initInterval( condition.applyHeal, 1000 );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = RecuperatingCondition
